import Index from '../pages/index';
import CodeAccessApplication from '../pages/codeAccessApplication/codeAccessApplication';
import { WizardProvider } from "../LoanApplicationContext";
import { routeCreator } from '../../../helpers/routeCreator';

const WrappedCodeAccessIndex = () => (
    <WizardProvider>
      <Index />
    </WizardProvider>
  );

export const ROUTE_LOAN_APPLICATION = routeCreator(
  WrappedCodeAccessIndex,
  '/loans/application/:id',
  'Loan Application',
  'page.loan.application',
  { exact: true }
);


const WrappedCodeAccess = () => (
  <WizardProvider>
    <CodeAccessApplication />
  </WizardProvider>
);

export const ROUTE_LOAN_APPLICATION_CODE_ACCESS = routeCreator(
  WrappedCodeAccess,
  '/loans/access-application',
  'Code Access Loan Application',
  'page.loan.code.access',
  { exact: true }
);


const router = {
  ROUTE_LOAN_APPLICATION,
  ROUTE_LOAN_APPLICATION_CODE_ACCESS,
};

export default router;
